<template>
  <div>
    <modal v-if="this.tabId == 1" 
      :show="canSign && !isPartnerAccount" 
      :showClose="false" 
      headerClasses="justify-content-center"
      v-bind:middle="true"
      type="notice">
        <h4 slot="header" class="title title-up">Reminder</h4>
        <hr />
        <div class="container">
            <div class="row">
               {{this.description}}
            </div>
        </div>
        <template slot="footer">
            <div class="container alert_footer">
                <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="modals.submitAction">
                    Acknowledge
                </base-button>
            </div>
        </template>
    </modal>
    <collapse   :multiple-active="false" :active-index="-1">
      <collapse-form-item
      v-if="preOrder.isRatified && !isPartnerAccount" 
        id="AuthorizedRequestorStep"
        title="Ratification (Document Upload)"
        @tabOpen="loadItem"
        :status="authorizedRatifierRatificationStatus"
        v-bind:tabChange="getAllState.authorized"
        v-on:moveAway="changeSignStatus"
        name="1"
      >
        <div>
        
          <authorized-ratifier-authorize
         
          :is-read-only="isReadOnly"
            v-on:show-document-tab="showDocumentTab"
            v-on:no-document-file-acceptor="resetUploadFileAcceptor"
            v-on:transaction-acceptor-file-uploaded="fileUploadedAcceptor"
            :uploadedStatus="transactionFileUploaded || transactionAcceptorFileUploaded"
            ref="ratificationStep"
            @validated="onSubStepValidated"
          >
          </authorized-ratifier-authorize>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AuthorizedRequestorStep"
        title="Authorized Requestor (Signature)"
        @tabOpen="loadItem"
        :status="authorizedRequestorAuthorizeStatus"
        v-bind:tabChange="getAllState.authorized"
        v-on:moveAway="changeSignStatus"
        name="2"
      >
        <div>
          <authorized-requestor-authorize
            :is-read-only="isReadOnly"
            ref="AuthorizedRequestorStep"
            v-on:show-document-tab="showDocumentTab"
            v-on:no-document-file-requestor="resetUploadFileRequestor"
            v-bind:uploadedStatus="transactionFileUploaded || transactionAcceptorFileUploaded"
            @validated="onSubStepValidated"
            @transaction-file-uploaded="fileUploaded()"
          >
          </authorized-requestor-authorize>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AuthorizedAcceptorStep"
        title="Authorized Acceptor (Signature)"
        @tabOpen="loadItem"
        :status="authorizedAcceptorAuthorizeStatus"
        v-bind:tabChange="getAllState.authorized"
        name="3"
      >
        <div>
          <authorized-acceptor-authorize
            :is-read-only="isReadOnly"
            v-on:show-document-tab="showDocumentTab"
            v-on:no-document-file-acceptor="resetUploadFileAcceptor"
            v-on:transaction-acceptor-file-uploaded="fileUploadedAcceptor"
            :uploadedStatus="transactionFileUploaded || transactionAcceptorFileUploaded"
            ref="AuthorizedAcceptorStep"
            @validated="onSubStepValidated"
          >
          </authorized-acceptor-authorize>
        </div>
      </collapse-form-item>
    </collapse>
  </div>
</template>

<script>
import AuthorizedRequestorAuthorize from "@/components/App/order/authorization/signature/AuthorizedRequestorAuthorize.vue";
import AuthorizedAcceptorAuthorize from "@/components/App/order/authorization/signature/AuthorizedAcceptorAuthorize.vue";
import AuthorizedRatifierAuthorize from "@/components/App/order/authorization/signature/AuthorizedRatifierAuthorize.vue"
import { Select, Option, Alert } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem, Modal } from "@/components/index";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";


export default {
  name: "Authorization",
  props: ["isReadOnly", "tabId"],
  components: {
    AuthorizedRequestorAuthorize,
    AuthorizedAcceptorAuthorize,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    [Alert.name]: Alert,
    AuthorizedRatifierAuthorize,
    Modal
  },
  data() {
    return {
      status: null,
      canSign: true,
      modals: {
          notice: this.canSign,
          submitAction: this.closeBanner,
      },
      middle:false,
      transactionFileUploaded: false,
      transactionAcceptorFileUploaded: false
    };
  },
  async mounted() {
    this.getAuthorizedRequestorAuthorizeStatus(this.$route.params.id);
    this.getAuthorizedAcceptorAuthorizeStatus(this.$route.params.id);
    this.getRatificationStatus(this.$route.params.id);
    this.getPreOrder(this.$route.params.id);
    await this.getAuthorizedRatifier(this.$route.params.id)
    let ctx = this;
    // reload the status when the existing signature doc type is updated
    EventBus.$on('doc-type-change', async() => {
      ctx.$loaderApp.addRequest();
      await this.getAuthorizedRatifier(this.$route.params.id)
      await this.getAuthorizedRequestorAuthorizeStatus(ctx.$route.params.id);
      await this.getAuthorizedAcceptorAuthorizeStatus(ctx.$route.params.id);
      await this.getRatificationStatus(this.$route.params.id)
      ctx.$loaderApp.completeRequest();

    });
  },
  computed: {
    ...mapGetters({
      authorizedRatifierRatificationStatus: "authorizedRatifier/authorizedRatifierAuthorizeStatus",
      authorizedAcceptorAuthorizeStatus: "authorizedAcceptor/authorizedAcceptorAuthorizeStatus",
      authorizedRequestorAuthorizeStatus:"authorizedRequestor/authorizedRequestorAuthorizeStatus",
      requisitionNumber: "orderMetadata/requisitionNumber",
      orderStatus: "orderMetadata/orderStatus",
      getAllState: "moduleState/getAllStates",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      orderMetadata: "orderMetadata/orderMetadata",
        preOrder: "preOrderDetail/preOrder",
      isPartnerAccount: "authentication/isPartnerAccount",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
    }),
    description: function() {
      if(this.isRikOrEveOrder) {
        return "IAW CJCSI 2120.01E, Enclosure D, if a RIK or EVE is not completed as agreed upon, then the order must be converted to a monetary transaction and a fund cite(s) must be obtained and applied to the order."
      } else{
        if(this.isUsBuyOrder) {
            return "IAW CJCSI 2120.01E Enclosure D, paragraphs 3.a.3.(b), if the United States is acquiring LSSS for monetary reimbursement, the designated ACSA PM will coordinate with the responsible Service Component or sub unified Command financial management element before signing the ACSA order form to obtain fund certification for the dollar value of the order.  The fund cite will be noted on the ACSA order form. U.S. personnel should proceed to the INVOICE TAB and ensure a proper fund citation is entered before obtaining the Authorized Requestor signature." 
          } else { 
            return "IAW CJCSI 2120.01E Enclosure D, paragraphs 3.a.3.(c), if the United States is transferring the LSSS for monetary reimbursement, the ACSA order must reflect the fund cite of the account to which the reimbursement must be credited.  The fund cite will be noted on the ACSA order form. U.S. personnel should proceed to the INVOICE TAB and ensure a proper fund citation is entered before obtaining the Authorized Requestor signature."
      }
    }
    },
  },
  watch: {
      authorizedAcceptorAuthorizeStatus(after, pre) {
        if(!after)
          this.canSign = (this.orderStatus === 'DRAFT' || this.orderStatus === 'SUBMITTED') && (!this.authorizedRequestorAuthorizeStatus || !this.authorizedAcceptorAuthorizeStatus);
      },
      authorizedRequestorAuthorizeStatus(after, pre) {
        if(!after) {
          this.canSign = (this.orderStatus === 'DRAFT' || this.orderStatus === 'SUBMITTED') && (!this.authorizedRequestorAuthorizeStatus || !this.authorizedAcceptorAuthorizeStatus);
        }
      }
  },
  methods: {
    ...mapActions({
      getAuthorizedRequestorAuthorizeStatus:"authorizedRequestor/getAuthorizedRequestorAuthorizeStatus",
      getRatificationStatus: "authorizedRatifier/getAuthorizedRatifierAuthorizeStatus",
      getAuthorizedAcceptorAuthorizeStatus:"authorizedAcceptor/getAuthorizedAcceptorAuthorizeStatus",
      submitAuthorization: "orderMetadata/submitAuthorization",
      getAuthorizedRatifier : "authorizedRatifier/getAuthorizedRatifier",
      getPreOrder: "preOrderDetail/getPreOrder",
      getDisbursingCollectionOutstandingBalanceWithoutFormat: "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalanceWithoutFormat",
    }),
    changeSignStatus() {
      this.canSign = ((this.orderStatus === 'DRAFT' || this.orderStatus === 'SUBMITTED') && (!this.authorizedRequestorAuthorizeStatus || !this.authorizedAcceptorAuthorizeStatus));
    },
    closeBanner() {
      this.canSign = false;
    },
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'TRANSACTION COMPLETION')
    },
    async loadItem(ref) {
      await this.getAuthorizedRatifier(this.$route.params.id)
      await this.getRatificationStatus(this.$route.params.id)
      return this.$refs[ref].loaded();
    },
    fileUploaded(){
      this.transactionFileUploaded = true
    },
    fileUploadedAcceptor() {
      this.transactionAcceptorFileUploaded = true;
    },
    resetUploadFileRequestor() {
      this.transactionFileUploaded = false;
    },
    resetUploadFileAcceptor() {
      this.transactionAcceptorFileUploaded = false;
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}

.bannerBtn {
  float: right;
}
</style>
